import { useTranslation } from '@doccareplus/i18n';
import { DnaAnimation } from './DnaAnimation';

// Left brand panel for the portal login, mirroring the exact typography and mint accent styling of the clinic app.
export function PortalBrandSide() {
  const { t } = useTranslation('portal');

  return (
    <div className="relative hidden flex-1 flex-col justify-between overflow-hidden bg-[linear-gradient(135deg,var(--brand-900),var(--brand-700),var(--brand-500))] p-[48px] text-white select-none lg:flex">
      {/* Animated SVG Background */}
      <DnaAnimation />

      {/* 1. Branding Header */}
      <div className="z-10 flex items-center gap-3 select-none">
        <img src="/short_logo.svg" alt="DocCare+" className="h-[32px] w-[32px] brightness-0 invert" />
        <span className="text-lg font-bold tracking-wide text-white">DocCare+</span>
      </div>

      {/* 2. Central Branding Info (Font-bold) */}
      <div className="z-10 flex max-w-[480px] flex-col gap-4 select-none">
        <h1 className="text-[38px] font-bold leading-tight tracking-tight text-white drop-shadow-sm">
          Your care,{' '}
          <span className="text-[#33d6c1] bg-gradient-to-r from-[#33d6c1] to-[#0dd3ba] bg-clip-text text-transparent">
            always within reach.
          </span>
        </h1>
        <p className="text-[15px] font-normal leading-relaxed text-[var(--brand-100)]/85">
          {t('auth.brandTagline', 'Book visits, view prescriptions, and manage your family’s health — all from your phone.')}
        </p>
      </div>

      {/* 3. Footer */}
      <div className="z-10 text-[12px] text-[var(--brand-100)]/70 select-none">
        {t('auth.brandFooter', 'Private & secure patient portal')}
      </div>
    </div>
  );
}
